import { render, staticRenderFns } from "./LoggedInAs.vue?vue&type=template&id=6ef6c2d2&scoped=true"
import script from "./LoggedInAs.vue?vue&type=script&lang=ts"
export * from "./LoggedInAs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6c2d2",
  null
  
)

export default component.exports